import { CostEstimationService } from './cost-estimation.service';
import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as CostEstimationActions from './cost-estimation.action';
import * as CostEstimationModels from '../../models/cost-estimation/cost-estimation';
import * as Models from '../../models/commonModels';
import { CostEstimationSearchModel } from '../../models/cost-estimation/cost-estimationSearch';
import { BannerService } from '../../shared/services/banner.service';
import { saveAs } from "file-saver";
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { StorageService } from '../../shared/services/storage.service';


export interface CostEstimationStateModel {
  CostEstimationList: CostEstimationModels.CostEstimationListModel;
  CostEstimation: Models.Response<CostEstimationModels.CostEstimationModel>;
  CostEstimationSearch: CostEstimationSearchModel;
  CostEstimationStatus: CostEstimationModels.CostEstimationStatusDictionaryListModel;
  ServiceLineRemoveStatus: Models.Response<number>;
  PartLineRemoveStatus: Models.Response<number>;
  ServiceLineAcceptStatus: Models.Response<CostEstimationModels.CostEstimationServiceLine>;
  ServiceLineDoneStatus: Models.Response<CostEstimationModels.CostEstimationServiceLine>;
  PartLineAcceptStatus: Models.Response<CostEstimationModels.CostEstimationPartLine>;
  ProcessingPdf: number;
}


class DictionaryKeys {
  public static readonly CostEstimationStatus = "CostEstimationStatus";
}


@State<CostEstimationStateModel>({
  name: 'costestimationState',
  defaults: {
    CostEstimationList: null,
    CostEstimation: null,
    CostEstimationSearch: null,
    CostEstimationStatus: null,
    ServiceLineRemoveStatus: null,
    PartLineRemoveStatus: null,
    ServiceLineAcceptStatus: null,
    ServiceLineDoneStatus: null,
    PartLineAcceptStatus: null,
    ProcessingPdf: null,
  }
})

@Injectable()

export class CostEstimationState {

  constructor(
    private helperService: HelperService,
    private costEstimationService: CostEstimationService,
    private bannerService: BannerService,
    private storageService: StorageService
  ) { }

  @Selector()
  static CostEstimationList(state: CostEstimationStateModel) {
    return state.CostEstimationList;
  }

  @Selector()
  static CostEstimationStatusTypesDictionary(state: CostEstimationStateModel) {
    return state.CostEstimationStatus;
  }

  @Selector()
  static CostEstimation(state: CostEstimationStateModel) {
    return state.CostEstimation;
  }

  @Selector()
  static CostEstimationSearch(state: CostEstimationStateModel) {
    return state.CostEstimationSearch;
  }

  @Selector()
  static ServiceLineRemoveStatus(state: CostEstimationStateModel) {
    return state.ServiceLineRemoveStatus;
  }

  @Selector()
  static PartLineRemoveStatus(state: CostEstimationStateModel) {
    return state.PartLineRemoveStatus;
  }

  @Selector()
  static ServiceLineAcceptStatus(state: CostEstimationStateModel) {
    return state.ServiceLineAcceptStatus;
  }

  @Selector()
  static ServiceLineDoneStatus(state: CostEstimationStateModel) {
    return state.ServiceLineDoneStatus;
  }

  @Selector()
  static PartLineAcceptStatus(state: CostEstimationStateModel) {
    return state.PartLineAcceptStatus;
  }

  @Selector()
  static ProcessingPdf(state: CostEstimationStateModel) {
    return state.ProcessingPdf;
  }

  @Action(CostEstimationActions.SetCostEstimation)
  setCostEstimation(
    context: StateContext<CostEstimationStateModel>,
    action: CostEstimationActions.SetCostEstimation
  ) {
    const errorMessage = 'Błąd zapisu szczegółów kosztorysu.';

    this.costEstimationService.set(action.CostEstimation).subscribe(
      ret => {
        if (ret.Success == true)
          this.bannerService.success('Zmiany kosztorysu zapisane.');

        context.setState(
          patch({
            CostEstimation: ret
          })
        );

      },

      (error) => {
        this.helperService.SaveException('CostEstimationActions.SetCostEstimation', error);
        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(CostEstimationActions.GetCostEstimation)
  getCostEstimation(
    context: StateContext<CostEstimationStateModel>,
    action: CostEstimationActions.GetCostEstimation
  ) {
    const errorMessage = 'Błąd zapisu szczegółów kosztorysu.';

    this.costEstimationService.get(action.CostEstimation).subscribe(
      ret => {
        context.setState(
          patch({
            CostEstimation: ret
          })
        );
      },

      (error) => {

        this.helperService.SaveException('CostEstimationActions.GetCostEstimation', error);
        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(CostEstimationActions.GetCostEstimationList)
  getCostEstimationList(
    context: StateContext<CostEstimationStateModel>,
    action: CostEstimationActions.GetCostEstimationList
  ) {

    const errorMessage = 'Błąd pobierania listy kosztorysów.';

    context.setState(
      patch({
        CostEstimationList: null
      })
    );

    this.costEstimationService.getList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            CostEstimationList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('CostEstimationActions.GetCostEstimationList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(CostEstimationActions.ServiceLineRemove)
  serviceLineRemove(
    context: StateContext<CostEstimationStateModel>,
    action: CostEstimationActions.ServiceLineRemove
  ) {

    const errorMessage = 'Błąd usuwania lini kosztorysu dla serwisu.';

    context.setState(
      patch({
        ServiceLineRemoveStatus: null
      })
    );

    this.costEstimationService.serviceLineRemove(action.ServiceLine).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            ServiceLineRemoveStatus: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('CostEstimationActions.ServiceLineRemove', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(CostEstimationActions.PartLineRemove)
  partLineRemove(
    context: StateContext<CostEstimationStateModel>,
    action: CostEstimationActions.PartLineRemove
  ) {

    const errorMessage = 'Błąd usuwania lini kosztorysu dla serwisu.';

    context.setState(
      patch({
        PartLineRemoveStatus: null
      })
    );

    this.costEstimationService.partLineRemove(action.PartLine).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            PartLineRemoveStatus: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('CostEstimationActions.PartLineRemove', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(CostEstimationActions.SetCostEstimationSearch)
  setCostEstimationSearch(
    context: StateContext<CostEstimationStateModel>,
    action: CostEstimationActions.SetCostEstimationSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        CostEstimationSearch: action.Search
      }));

    context.dispatch(new CostEstimationActions.GetCostEstimationList(action.Search));
  }

  @Action(CostEstimationActions.SetCostEstimationListPage)
  setDepositeListPage(
    context: StateContext<CostEstimationStateModel>,
    action: CostEstimationActions.SetCostEstimationListPage
  ) {

    context.setState(
      patch({
        CostEstimationSearch: action.Search
      }));

    context.dispatch(new CostEstimationActions.GetCostEstimationList(action.Search));
  }

  @Action(CostEstimationActions.ResetCostEstimationSearch)
  resetDepositeSearch(
    context: StateContext<CostEstimationStateModel>
  ) {

    const state = context.getState();
    const costEstimationSearch = new CostEstimationSearchModel();
    costEstimationSearch.ItemsPerPage = state.CostEstimationSearch.ItemsPerPage;

    context.setState(
      patch({
        CostEstimationSearch: costEstimationSearch
      }));

    context.dispatch(new CostEstimationActions.GetCostEstimationList(state.CostEstimationSearch));
  }

  @Action(CostEstimationActions.DisposeSearch)
  disposeSearch(
    context: StateContext<CostEstimationStateModel>
  ) {
    context.setState(
      patch({
        CostEstimationSearch: null
      }));
  }

  @Action(CostEstimationActions.GetCostEstimationStatusDictionary)
  getCostEstimationStatusDictionary(
    context: StateContext<CostEstimationStateModel>,
    action: CostEstimationActions.GetCostEstimationList
  ) {

    const errorMessage = 'Błąd pobierania słownika statusów kosztorysów.';

    let storageKey = DictionaryKeys.CostEstimationStatus;

    context.setState(
      patch({
        CostEstimationStatus: this.storageService.getItemJSON(storageKey)
      })
    );

    const state = context.getState();

    if (!state.CostEstimationStatus) {

      this.costEstimationService.getStatusDictionary().subscribe((ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              CostEstimationStatus: ret
            })
          );

          this.storageService.setItemJSON(storageKey, ret);

          return ret;

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.helperService.SaveException('CostEstimationActions.GetCostEstimationStatusDictionary', error);

          this.bannerService.error(errorMessage);
        });

    }
  }

  @Action(CostEstimationActions.ServiceLineAccept)
  serviceLineAccept(
    context: StateContext<CostEstimationStateModel>,
    action: CostEstimationActions.ServiceLineAccept
  ) {
    const errorMessage = 'Błąd usuwania lini kosztorysu dla serwisu.';

    context.setState(
      patch({
        ServiceLineAcceptStatus: null
      })
    );

    this.costEstimationService.serviceLineAccept(action.ServiceLine).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            ServiceLineAcceptStatus: ret
          })
        );
        return ret;
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('CostEstimationActions.ServiceLineAccept', error);
        this.bannerService.error(errorMessage);
      });
  }

  @Action(CostEstimationActions.ServiceLineDone)
  serviceLineDone(
    context: StateContext<CostEstimationStateModel>,
    action: CostEstimationActions.ServiceLineDone
  ) {
    const errorMessage = 'Błąd wykonania lini kosztorysu dla serwisu.';

    context.setState(
      patch({
        ServiceLineDoneStatus: null
      })
    );

    this.costEstimationService.serviceLineDone(action.ServiceLine).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            ServiceLineDoneStatus: ret
          })
        );
        return ret;
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('CostEstimationActions.ServiceLineDone', error);
        this.bannerService.error(errorMessage);
      });
  }

  @Action(CostEstimationActions.SetNote)
  setNote(
    context: StateContext<CostEstimationStateModel>,
    action: CostEstimationActions.SetNote
  ) {
    const errorMessage = 'Błąd zapisu notatki.';

    this.costEstimationService.setNote(action.Note).subscribe(
      ret => {
        if (ret.Success == true)
          this.bannerService.success('Notatka została zapisana.');

        context.setState(
          patch({
            CostEstimation: ret
          })
        );

      },

      (error) => {
        this.helperService.SaveException('CostEstimationActions.SetNote', error);
        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(CostEstimationActions.PartLineAccept)
  partLineAccept(
    context: StateContext<CostEstimationStateModel>,
    action: CostEstimationActions.PartLineAccept
  ) {
    const errorMessage = 'Błąd akceptacji części dla kosztorysu dla serwisu.';

    context.setState(
      patch({
        PartLineAcceptStatus: null
      })
    );

    this.costEstimationService.partLineAccept(action.PartLine).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            PartLineAcceptStatus: ret
          })
        );
        return ret;
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('CostEstimationActions.PartLineAccept', error);
        this.bannerService.error(errorMessage);
      });
  }


  @Action(CostEstimationActions.GetCostEstimationPDF)
  getCostEstimationPDF(
    context: StateContext<CostEstimationStateModel>,
    action: CostEstimationActions.GetCostEstimationPDF
  ) {

    this.bannerService.quickInfo('Rozpoczęto generowanie dokumentu pdf, Proszę czekać.');

    this.costEstimationService.getCostEstimationPDF(action.Search).subscribe(ret => {
      let file = new File([ret], `Kosztorys -${this.helperService.TimeStamp()}.pdf`, { type: 'application/pdf' });
      if (action.Search.State == false) {
        file = new File([ret], `Kosztorys dla Klienta -${this.helperService.TimeStamp()}.pdf`, { type: 'application/pdf' });
      } else {
        file = new File([ret], `Kosztorys dla Serwisu -${this.helperService.TimeStamp()}.pdf`, { type: 'application/pdf' });
      }
      saveAs(file);
    },
      (error) => {

        this.helperService.SaveException('CostEstimationActions.GetSelectedToPDF', error);

        this.bannerService.error('Błąd pobierania pliku pdf.');
      },
      () => {
        context.setState(
          patch({
            ProcessingPdf: Math.random()
          })
        );
      }
    );
  }

  @Action(CostEstimationActions.Accept)
  accept(
    context: StateContext<CostEstimationStateModel>,
    action: CostEstimationActions.Accept
  ) {
    const errorMessage = 'Błąd akceptacji kosztorysu.';

    context.setState(
      patch({
        CostEstimation: null
      })
    );

    this.costEstimationService.accept(action.Accept).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            CostEstimation: ret
          })
        );
        return ret;
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('CostEstimationActions.Accept', error);
        this.bannerService.error(errorMessage);
      });
  }

  @Action(CostEstimationActions.Cancel)
  cancel(
    context: StateContext<CostEstimationStateModel>,
    action: CostEstimationActions.Cancel
  ) {
    const errorMessage = 'Błąd anulowania kosztorysu.';

    context.setState(
      patch({
        CostEstimation: null
      })
    );

    this.costEstimationService.cancel(action.Cancel).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            CostEstimation: ret
          })
        );
        return ret;
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('CostEstimationActions.Cancel', error);
        this.bannerService.error(errorMessage);
      });
  }

  @Action(CostEstimationActions.DoIt)
  doIt(
    context: StateContext<CostEstimationStateModel>,
    action: CostEstimationActions.DoIt
  ) {
    const errorMessage = 'Błąd akceptacji kosztorysu.';

    context.setState(
      patch({
        CostEstimation: null
      })
    );

    this.costEstimationService.doIt(action.DoIt).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            CostEstimation: ret
          })
        );
        return ret;
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('CostEstimationActions.Accept', error);
        this.bannerService.error(errorMessage);
      });
  }

  @Action(CostEstimationActions.AcceptAll)
  acceptAll(
    context: StateContext<CostEstimationStateModel>,
    action: CostEstimationActions.AcceptAll
  ) {
    const errorMessage = 'Błąd akceptacji lini kosztorysu.';

    context.setState(
      patch({
        CostEstimation: null
      })
    );

    this.costEstimationService.acceptAll(action.CostEstimation).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            CostEstimation: ret
          })
        );
        return ret;
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('CostEstimationActions.AcceptAll', error);
        this.bannerService.error(errorMessage);
      });
  }
} 
